import * as XLSX from 'xlsx';
import {TableElement} from './TableElement';

const getFileName = (name: string) => {
  const timeSpan = new Date().toISOString();
  const sheetName = name || 'ExportResult';
  const fileName = `${sheetName}-${timeSpan}`;
  return {
    sheetName,
    fileName,
  };
};

export class TableExportUtil {
  static exportToExcel(arr: Partial<TableElement>[], name: string) {
    if (!arr.length) return;
    const { sheetName, fileName } = getFileName(name);

    // Nombres de columnas dinamicos
    const columns = Object.keys(arr[0]);
    const data = [
      columns,
      ...arr.map(row => columns.map(col => row[col] ?? ''))
    ];

    // Usamos aoa_to_sheet para poder aplicar estilos
    const ws = XLSX.utils.aoa_to_sheet(data);

    // Estilo encabezado (primera fila)
    columns.forEach((_, colIdx) => {
      const cellAddr = XLSX.utils.encode_cell({ c: colIdx, r: 0 });
      if (ws[cellAddr]) {
        ws[cellAddr].s = {
          font: { bold: true, color: { rgb: "FFFFFF" } },
          fill: { fgColor: { rgb: "007bff" } },
          alignment: { horizontal: "center" },
          border: {
            top: { style: "thin", color: { rgb: "AAAAAA" } },
            left: { style: "thin", color: { rgb: "AAAAAA" } },
            bottom: { style: "thin", color: { rgb: "AAAAAA" } },
            right: { style: "thin", color: { rgb: "AAAAAA" } }
          }
        };
      }
    });

    // Bordes y alineacion para las demas celdas
    for (let r = 1; r < data.length; ++r) {
      for (let c = 0; c < columns.length; ++c) {
        const cellAddr = XLSX.utils.encode_cell({ c, r });
        if (ws[cellAddr]) {
          ws[cellAddr].s = {
            alignment: { horizontal: "left", vertical: "center" },
            border: {
              top: { style: "thin", color: { rgb: "DDDDDD" } },
              left: { style: "thin", color: { rgb: "DDDDDD" } },
              bottom: { style: "thin", color: { rgb: "DDDDDD" } },
              right: { style: "thin", color: { rgb: "DDDDDD" } }
            }
          };
        }
      }
    }

    // Autoajuste de columnas
    ws['!cols'] = columns.map((col, i) => ({
      wch: Math.max(
        col.length,
        ...arr.map(row => row[col] != null ? row[col]!.toString().length : 0)
      ) + 2
    }));

    // Crear workbook y exportar
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, sheetName);
    XLSX.writeFile(wb, `${fileName}.xlsx`); // Listo, sin FileSaver
  }

  // static exportToPDF(exportData: any[]) {
  //   const doc = new jsPDF();
  //   const dataValue: any = Object.keys(exportData).map(function (
  //     personNamedIndex: any
  //   ) {
  //     return Object.values(exportData[personNamedIndex]);
  //   });
  //   const keys: any = Object.keys(exportData[0]);

  //   autoTable(doc, {
  //     head: [keys],
  //     body: dataValue,
  //   });

  //   const { fileName } = getFileName('pdf');

  //   doc.save(`${fileName}.pdf`);
  // }
}
